// extracted by mini-css-extract-plugin
module.exports = {"container":"_1g8PeQ_R","menuContainer":"_2a1Flni2"};